import { Files } from "lucide-react";
import { useI18n } from "../lib/i18n.js";

export function BrandMark({ compact = false }: { compact?: boolean }) {
  const { t } = useI18n();
  return (
    <div className={`brand-mark ${compact ? "compact" : ""}`}>
      <span className="brand-symbol" aria-hidden="true">
        <Files size={compact ? 20 : 26} />
      </span>
      <span className="brand-copy">
        <strong>{t("brand")}</strong>
      </span>
    </div>
  );
}
